import { Component, inject, OnInit } from '@angular/core';
import { CustomModal } from '@workflow/dynamic-render/page/shared/core-custom-page.decorator';
import { WorkflowPageNavigationService } from '@workflow/service/workflow-page-navigation/workflow-page-navigation.service';
import { OaoPageHelper } from '../../helper/oao-page.helper';
import { StatefulService } from '@app/service/stateful.service';
@CustomModal('oao-confirm-delete-beneficiary')
@Component({
  selector: 'ecp-oao-confirm-delete-beneficiary',
  templateUrl: './confirm-delete-beneficiary.component.html'
})
export class ConfirmDeleteBeneficiaryComponent implements OnInit {
  removeAll = false;
  private readonly statefulService = inject(StatefulService);

  constructor(public workflowPageNavigationService: WorkflowPageNavigationService, private readonly flowHelper: OaoPageHelper) {}
  ngOnInit(): void {
    const cardId = this.statefulService.wrap('ss:beneficiaryRemoveCardId').valueString;
    if (!cardId?.length) {
      this.removeAll = true;
    } else {
      this.removeAll = false;
    }
  }

  public confirmDeleteBeneficiary = (): void => {
    /** If yes, Clearing All fields */

    this.flowHelper.agreeOAOBeneficiaryRemoval();
    this.statefulService.wrap('ss:showBeneficiaryRemoveModal').value = false;
  };

  public cancelDeleteBeneficiary = (): void => {
    this.flowHelper.cancelOAOBeneficiaryRemoval();
    this.statefulService.wrap('ss:showBeneficiaryRemoveModal').value = false;
  };
}
